<template>
    <div class="itinerario">
        <RightPanel title="Itinerario">
            <template>
                <div class="timeline" >
                    <div v-if="isMinusDay" class="timeline-item">
                        <ItemDay :value="startDate"/>
                        <ItemVoloAndata/>
                    </div>
                    <div class="timeline-item" v-for="(item, index) in days" :key="index">
                        <ItemDay :value="item.day"/>
                        <ItemVoloAndata v-if="index===0" :is-destinazione="isMinusDay" :day="item.day"/>
                        <ItemService :is-trasferimento="true" v-if="index === 0 && showTrasferimento" :day="item.day" :days="days" @detail="onServiceDetail" />
                        <ItemTourDay :value="item"/>
                        <ItemVoloRitorno v-if="index===days.length-1"/>
                        <ItemService :is-trasferimento="true" v-if="(index === days.length - 1) && showTrasferimento" :day="item.day" :days="days" @detail="onServiceDetail"/>
                    </div>
                    <div v-if="isPlusDay" class="timeline-item">
                        <ItemDay :value="dayAdded"/>
                        <ItemVoloRitorno :is-destinazione="true"/>
                    </div>
                </div>
            </template>
        </RightPanel>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import RightPanel from '../../../templates/RightPanel'
import ItemDay from '../../common/itinerario/ItemDay'
import ItemService from '../../common/itinerario/ItemService'
import ItemTourDay from '../../common/itinerario/ItemTourDay'
import ItemVoloAndata from '../../common/itinerario/ItemVoloAndata'
import ItemVoloRitorno from '../../common/itinerario/ItemVoloRitorno'
import {isSameDate} from '../../../../utils/helper'
import {toDateFromServer} from '../../../../utils/formatter'

export default {
  name: 'Itinerario',
  components: {ItemVoloRitorno, ItemVoloAndata, ItemTourDay, ItemService, ItemDay, RightPanel},
  computed: {
    days () {
      const list = this.tour.dayByDay
      return list.map((item, index) => {
        const i = this.$store.getters.isGiornoSuccessivoObbligatorio ? index + 1 : index
        const day = this.$moment(this.startDate).add(i, 'days').toDate()
        return {title: item.descriptionTitle, description: item.description, day, categoryDescriptions: item.categoryDescriptions}
      })
    },
    adminTour () {
      const obj = this.getTours()
      const tour = obj.list.find(item => {
        return item.codice === this.tour.productID
      })
      return tour
    },
    tour () {
      return this.getTour().anagrafica.detailResponse.detail
    },
    startDate () {
      return this.getSearch().partenza
    },
    showTrasferimento () {
      return this.getTrasferimentiCounter() > 0
    },
    dayAdded () {
      const length = this.flight.voli.length
      return toDateFromServer(this.flight.voli[length - 1].destinazione.dataOra.date.date)
    },
    isMinusDay () {
      return this.$store.getters.isGiornoSuccessivoObbligatorio
    },
    isPlusDay () {
      const length = this.flight.voli.length
      const partenzaDate = toDateFromServer(this.flight.voli[0].partenza.dataOra.date.date)
      const destinazioneDate = toDateFromServer(this.flight.voli[length - 1].destinazione.dataOra.date.date)
      return !isSameDate(partenzaDate, destinazioneDate)
    },
    flight () {
      return this.getFlightTo()
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getTour', 'getTours', 'getTrasferimentiCounter', 'getFlightTo']),
    onServiceDetail (item) {
      this.$emit('service', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/ItinerarioTour.vue